<template>
  <div class="publicMain">
    <el-row class="leftClass">
      <el-button size="mini" type="primary" style="margin-bottom: 10px" @click="openDialog('add')">{{ $t('qxgl.addedBtn') }}</el-button>
    </el-row>
    <el-row>
      <el-table :data="tableData" row-key="qid" border style="width: 100%; font-size: 12px" v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')" 
        element-loading-spinner="el-icon-loading"
        :default-expand-all="false" :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :header-cell-style="$store.state.headerCellStyle" :cell-style="$store.state.cellStyle">
        <el-table-column prop="pid" header-align="center" :label="$t('qxgl.parentId')">
          <template slot-scope="scope">
            {{ scope.row.qname }}
          </template>
        </el-table-column>
        <el-table-column prop="qid" header-align="center" align="center" :label="$t('qxgl.permissionId')"></el-table-column>
        <el-table-column prop="qname" header-align="center" align="center" :label="$t('qxgl.qname')"></el-table-column>
        <el-table-column prop="xh" header-align="center" align="center" :label="$t('qxgl.xh')"></el-table-column>
        <el-table-column prop="path" header-align="center" align="center" :label="$t('qxgl.path')"></el-table-column>
        <el-table-column :label="$t('qxgl.operation')" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-button style="display: none" type="text" v-if="scope.row.jc === '0'" @click="openDialog('edit', scope.row)">{{ $t('qxgl.editBtn') }}</el-button>
            <el-button type="text" v-else @click="openDialog('edit', scope.row)">{{ $t('qxgl.editBtn') }}</el-button>
            <el-button style="display: none" type="text" v-if="scope.row.jc === '0'" @click="openDialog('del', scope.row)">{{ $t('qxgl.deleteBtn') }}</el-button>
            <el-button type="text" v-else @click="openDialog('del', scope.row)">{{ $t('qxgl.deleteBtn') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" top="10vh"
      :close-on-click-modal="false" :close-on-press-escape="true" @close="handleClose">
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
            <!-- "el-icon-document-add" -->
          </span>
        </i>
      </label>
      <el-card>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px"
          :validate-on-rule-change="false" size="small">
          <el-row>
            <el-col :offset="addSpan==12?0:3" :span=addSpan>
              <el-form-item :label="$t('qxgl.parentId')" prop="pid">
                <el-select style="width: 100%" v-model="ruleForm.pid" filterable :placeholder="$t('yhgl.ruleSelectMsg') + $t('yhgl.tableColRole')" v-if="ruleForm.jc == '2'&&saveFlg == 'edit'">
                  <el-option
                          v-for="item in optionsPid"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                  ></el-option>
                </el-select>
                <el-input disabled v-model="ruleForm.pid" v-else></el-input>
              </el-form-item>
              <el-form-item :label="$t('qxgl.permissionId')" prop="qid">
                <el-input disabled v-model="ruleForm.qid"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qxgl.qname')" prop="qname">
                <el-input v-model="ruleForm.qname"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qxgl.xh')" prop="xh">
                <el-input v-model="ruleForm.xh"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qxgl.path')" prop="path">
                <el-input v-model="ruleForm.path"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qxgl.redirect')" prop="redirect">
                <el-input v-model="ruleForm.redirect"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qxgl.level')" prop="jc" style="">
                <el-input disabled v-model="ruleForm.jc"></el-input>
              </el-form-item>
                <el-form-item :label="$t('qxgl.urlflg')" prop="urlflg">
                    <el-select v-model="ruleForm.urlflg" :placeholder="$t('qxgl.qxz')" @change="componentdisabled">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
              <el-form-item :label="$t('qxgl.component')" prop="component">
                <el-input v-model="ruleForm.component" :disabled="disabledFlg"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qxgl.isHide')" prop="isHide">
                <el-radio-group v-model="ruleForm.isHide">
                  <el-radio label="1">{{ this.$i18n.locale == 'zh' ? '是' : 'yes' }}</el-radio>
                  <el-radio label="0">{{ this.$i18n.locale == 'zh' ? '否' : 'no' }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('common.iscy')" prop="iscy" v-if="ruleForm.jc == '2'">
                <el-radio-group v-model="ruleForm.iscy">
                  <el-radio label="1">{{ this.$i18n.locale == 'zh' ? '是' : 'yes' }}</el-radio>
                  <el-radio label="0">{{ this.$i18n.locale == 'zh' ? '否' : 'no' }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :offset="2" :span=addSpan-2 style="font-size: 14px;" v-if="addSpan == 12">
              <el-row style="text-align: left;">
                <span style="font-weight: bold;">{{ $t('qxgl.permTreeTitle') }}</span>
                <el-tree :data="treeData" ref="qxTree" style="margin-top: 10px" node-key="qid" v-if="treeFlg"
                  :props="treeDefaultProps" :expand-on-click-node="false" accordion
                  @node-click="handleNodeClick" :default-expanded-keys="['0']">
                </el-tree>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">{{ $t('qxgl.cancelBtn') }}</el-button>
        <el-button type="primary" size="small" @click="submitForm('ruleForm')">{{ $t('qxgl.saveBtn') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "qxgl",
  computed: {
    rules() {    // 模态框数据校验规则
      return {
        pid: [
          { required: true, message: this.$t('qxgl.rulePid'), trigger: 'blur' },
        ],
        qid: [
          { required: true, message: this.$t('qxgl.ruleQid'), trigger: 'blur' }
        ],
        qname: [
          { type: 'string', required: true, message: this.$t('qxgl.ruleQname'), trigger: 'blur' },
        ],
        xh: [
          { required: true, message: this.$t('qxgl.ruleXh'), trigger: 'blur' }
        ],
        path: [
          { required: true, message: this.$t('qxgl.rulePath'), trigger: 'blur' }
        ],
        // component: [
        //   { required: true, message: this.$t('qxgl.ruleComponent'), trigger: 'blur' }
        // ],
        urlflg: [
          { required: true, message: this.$t('qxgl.ruleurlflg'), trigger: 'change' }
        ],
        // isHide: [
        //   { required: true, message: this.$t('qxgl.ruleIsHide'), trigger: 'blur' }
        // ],
      }
    },
    // treeDefaultProps() {    // 默认权限数据节点绑定数据
    //   return {
    //     label: 'qname',
    //     children: "children"
    //   }
    // },
  },
  data() {
    return {
      options: [{
        value: '0',
        label: this.$t('qxgl.bdgn')
      }, {
        value: '1',
        label: this.$t('qxgl.xtlj')
      }],
      treeFlg: false,
      tableData: [],    // 权限表数据
      dialogFormVisible: false,    // 新增/编辑权限模态框
      dialogTitle: '',    // 模态框标题
      ruleForm: {         // 模态框数据
        pid: "",          // 父权限ID
        qid: "",          // 权限ID
        sysid: "",          // 系统ID
        xh: "",       // 序号
        path: "",         // 路径
        qname: "",         // 权限名称
        redirect: "",     // 权限重定向
        component: "",    // 权限组件
        urlflg: "",    // 链接区分
        isHide: "1",       // 菜单显隐状态
        iscy: "0",       // 是否常用状态
      },
      optionsPid: [],    // 父ID下拉列表
      treeData: [],    // 权限树数据
      treeDefaultProps: {    // 默认权限数据节点绑定数据
        label: "qname",
        children: "children"
      },
      dialogTitleIcon: '',    // 模态框标题图标
      addSpan: 12,    // 新增时布局
      saveFlg: '',    // 保存操作区分
      tabLoading: true,    // 表格请求数据loading层
      disabledFlg: false,
    };
  },
  methods: {
      componentdisabled(){
          if (this.ruleForm.urlflg == "1"){
              this.ruleForm.component = "";
              this.disabledFlg = true;
          } else {
              this.disabledFlg = false;
          }
      },
    // 查询权限
    selectQx() {
      this.$ajax.post('/api/getQxByQid').then((res) => {
        this.tabLoading = false;

        let a = this.$comUtils.getListData(
                res.data.data,
                "0",
                {
                  children: "children",
                  label: "qname",
                  id: "qid",
                  pid: "pid"
                },
                "array"
        );
        a[0].label = this.$t('common.all');
        a[0].qname = this.$t('common.all');
        this.tableData = a[0].children;

        this.treeData = a;
      })
    },
    /** 打开模态框 */
    openDialog(flg, row) {
      if(flg == 'add') {
        this.treeFlg = true;
        this.dialogFormVisible = true;
        this.disabledFlg = false;
        this.$nextTick(() => {
          this.$refs['ruleForm'].resetFields();
          this.addSpan = 12;
          this.dialogTitle = this.$t('qxgl.addDiaTitle');
          this.dialogTitleIcon = 'el-icon-document-add';
        })
      } else if(flg == 'edit') {
        this.selectPid();
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.$refs['ruleForm'].resetFields();
          this.addSpan = 14;
          this.dialogTitle = this.$t('qxgl.editDiaTitle');
          this.dialogTitleIcon = 'el-icon-edit-outline';
          this.ruleForm.pid = row.pid;
          this.ruleForm.qid = row.qid;
          this.ruleForm.xh = row.xh;
          this.ruleForm.path = row.path;
          this.ruleForm.qname = row.qname;
          this.ruleForm.redirect = row.redirect;
          this.ruleForm.isHide = row.isHide;
          this.ruleForm.urlflg = row.urlflg;
          this.ruleForm.jc = row.jc;
          this.ruleForm.iscy = row.iscy;
          if (this.ruleForm.urlflg == "1"){
            this.ruleForm.component = "";
            this.disabledFlg = true;
          } else {
            this.ruleForm.component = row.component;
            this.disabledFlg = false;
          }
        })

      } else if(flg == 'del') {
        this.delQx(row.qid);
      }
      this.saveFlg = flg;
    },
    /** 节点被点击时的回调 */
    handleNodeClick(data) {
      let maxQid = '';
      this.ruleForm.pid = data.qid;
      this.ruleForm.sysid = data.qid.slice(0,4);
      if(data.children.length == 0) {
        maxQid = data.qid;
        this.ruleForm.qid = data.qid + '001';
        this.ruleForm.xh = 1;
        this.ruleForm.jc = parseInt(data.jc)+1;
      } else {
        maxQid = data.children[data.children.length - 1].qid;
        this.ruleForm.qid = data.qid + (parseInt(maxQid.substring(maxQid.length - 3)) + 1).toString().padStart(3, '0');
        this.ruleForm.xh = parseInt(data.children[data.children.length - 1].xh) + 1;
        this.ruleForm.jc = parseInt(data.jc)+1;
      }
    },

    /** 父ID下拉 */
    selectPid() {
      let _this = this;
      _this.optionsPid = [];
      _this.$ajax
              .post("/api/selectqid", {})
              .then((res) => {
                if (res.data.code == "200") {
                  for (let tmp of res.data.data) {
                    _this.optionsPid.push({
                      label: tmp.QNAME,
                      value: tmp.QID,
                    });
                  }
                }
              });
    },

    /** 删除权限 */
    delQx(qid) {
      let _this = this;
      _this.$confirm(_this.$t('qxgl.deleteContent'), _this.$t('qxgl.deleteTitle'), {
        distinguishCancelAndClose: true,
        confirmButtonText: _this.$t('qxgl.confirmBtn'),
        cancelButtonText: _this.$t('qxgl.cancelBtn')
      }).then(res1 => {
        _this.$ajax.post("/api/delQx", _this.$qs.stringify({qid: qid})).then((res) => {
          if(res.data.code = '200') {
            _this.selectQx();
            _this.$message.success(_this.$t('qxgl.delSuccess'));
            _this.$requestUtil.getRouter().then(tmpResult => {
              _this.$comUtils.saveObjArr('menuRouter', tmpResult) // 存储路由到localStorage
              _this.$root.$emit('menuRouter', tmpResult);
            })
          }
        })
      }).catch(action => {
        // this.$message.info({
        //   message: action === 'cancel' ? '放弃保存并离开页面' : '停留在当前页面'
        // })
      });
    },
    /** 保存模态框数据 */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.saveFlg === 'add') {
            this.addQx();
          } else if(this.saveFlg === 'edit') {
            this.editQx();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /** 新增权限 */
    addQx() {
      let _this = this;
      _this.$ajax.post('/api/addQx', _this.ruleForm).then((res) => {
        _this.dialogFormVisible = false;
        if(res.data.code == '200') {
          _this.selectQx();
          _this.$message.success(_this.$t('qxgl.addSuccess'));
          _this.$requestUtil.getRouter().then(tmpResult => {
            _this.$comUtils.saveObjArr('menuRouter', tmpResult) // 存储路由到localStorage
            _this.$root.$emit('menuRouter', tmpResult);
          })
        }
      }).catch((error) => {
        _this.dialogFormVisible = false;
      });
    },
    /** 编辑权限 */
    editQx() {
      let _this = this;
      _this.$ajax.post('/api/updateQx', _this.ruleForm).then((res) => {
        _this.dialogFormVisible = false;
        if(res.data.code == '200') {
          _this.selectQx();
          _this.$message.success(_this.$t('qxgl.editSuccess'));
          _this.$requestUtil.getRouter().then(tmpResult => {
            _this.$comUtils.saveObjArr('menuRouter', tmpResult) // 存储路由到localStorage
            _this.$root.$emit('menuRouter', tmpResult);
          })
        }
      }).catch((error) => {
        _this.dialogFormVisible = false;
      });
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields();
      this.treeFlg = false;
    }
  },
  mounted() {
    this.selectQx();
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-radio {
  font-size: 12px;
  .el-radio__label {
    font-size: 12px;
  }
}
::v-deep .el-card__body {
  padding-bottom: 5px;
}

::v-deep .el-tree-node__label {
  font-size: 12px;
}
</style>
